import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import { Button, Grid, TextField, Typography } from "@mui/material";
import axios from "axios";
import { Controller, useForm } from "react-hook-form";
import Checkbox from "@mui/material/Checkbox";
import { useNavigate } from "react-router-dom";
import Moment from "moment";
import Swal from "sweetalert2";
import "react-toastify/dist/ReactToastify.css";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import moment from "moment";

const validationSchema = yup.object().shape({
  periodontalCondition: yup.string().required("Please Select One"),

  tonsilsEnlarged: yup.boolean().nullable().required("Please Select One"),

  bruxism: yup.boolean().nullable().required("Please Select One"),

  lockingOrLuxation: yup.boolean().nullable().required("Please Select One"),
  painOnMandibularMovement: yup
    .boolean()
    .nullable()
    .required("Please Select One"),
  smoothMovement: yup.boolean().nullable().required("Please Select One"),
  tendernessToPalpitation: yup
    .boolean()
    .nullable()
    .required("Please Select One"),
});
const DentistForm = (props) => {
  const { FormId, FormPatientId, PatientName, onFormSubmit, handleClose } =
    props;

  const fields = [
    "id",
    "patientId",
    "practiceId",
    "incisorRelationship",
    "overjetMM",
    "overbiteMM",
    "periodontalCondition",
    "tonsilsEnlarged",
    "bruxism",
    "maxLateralMovement_L_MM",
    "maxLateralMovement_R_MM",
    "maxOpeningMM",
    "maxProtrusionMM",
    "tendernessToPalpitation",
    "painOnMandibularMovement",
    "smoothMovement",
    "lockingOrLuxation",
    "epworth10Plus",
    "feelingFatigued",
    "notUsingCPAP",
    "headaches",
    "inappropriateDaytimeNapping",
    "ahI5Plus",
    "providerName",
    "providerSignature",
    "providerDate",
    "createdDate",
    "createdBy",
    "updatedDate",
    "updatedBy",
    "inactive",
  ];

  const defValues = {
    id: 0,
    patientId: 0,
    practiceId: 0,
    incisorRelationship: "",
    overjetMM: "",
    overbiteMM: "",
    periodontalCondition: "",
    tonsilsEnlarged: null,
    bruxism: null,
    maxLateralMovement_L_MM: "",
    maxLateralMovement_R_MM: "",
    maxOpeningMM: "",
    maxProtrusionMM: "",
    tendernessToPalpitation: null,
    painOnMandibularMovement: null,
    smoothMovement: null,
    lockingOrLuxation: null,
    epworth10Plus: null,
    feelingFatigued: null,
    notUsingCPAP: null,
    headaches: null,
    inappropriateDaytimeNapping: null,
    ahI5Plus: null,
    providerName: "",
    providerSignature: "",
    providerDate: "",
    createdDate: "",
    createdBy: "",
    updatedDate: "",
    updatedBy: "",
    inactive: false,
  };

  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = { Authorization: auth };

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: defValues,
  });

  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (FormId) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/PatientForms/GetFormDentistUseId?id=${FormId}`,
          { headers }
        )
        .then((response) => {
          fields.forEach((field) => {
            setValue(field, response[field]);
          });
          if (response?.providerDate) {
          setValue(
            "providerDate",
            moment(response.providerDate).format("YYYY-MM-DD")
          );
        }
        })
        .catch((error) => {
          console.error("Error loading form data:", error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to load form data",
          });
        });
    }
  }, [FormId]);

  const onSubmit = (data) => {
    setSubmitting(true);

    const postData = {
      ...data,
      patientId: FormPatientId,
    };
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/PatientForms/AddFormDentistUse`,
        postData,
        { headers }
      )
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Form Added!",
       html: `<p>Dental Assessment Form has been saved successfully.</p>`,
          confirmButtonColor: "#2196F3",
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) swalPopup.style.zIndex = 2200;
          },
        });
        if (onFormSubmit) {
          onFormSubmit(response.id);
        }

        handleClose();
        setSubmitting(false);
      })
      .catch((error) => {
        setSubmitting(false);
        Swal.fire({
          icon: "error",
          title: "Failed!",
          html: `<p>${
            error.response?.data?.message ||
            "Something went wrong. Please try again."
          }</p>`,
          confirmButtonColor: "#F44336",
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) swalPopup.style.zIndex = 2200;
          },
        });
      });
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* Header Section */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={12}>
            <Typography
              variant="h4"
              align="center"
              fontWeight="bold"
              color="primary"
              gutterBottom
            >
              DENTAL ASSESSMENT FORM 
            </Typography>
            <Typography variant="body1" align="center" sx={{ mb: 3 }}>
              Patient: <strong>{PatientName}</strong>
            </Typography>
          </Grid>
        </Grid>

        {/* Occlusion Section */}
        <Grid
          container
          spacing={3}
          sx={{ m: 2, p: 2, backgroundColor: "#f8f9fa", borderRadius: 2 }}
        >
          <Grid item xs={12}>
            <Typography
              variant="h6"
              fontWeight="bold"
              color="primary"
              gutterBottom
            >
              Occlusion Assessment
            </Typography>
          </Grid>

          {/* Incisor Relationship */}
          <Grid item xs={12} md={6}>
            <Typography variant="body2" fontWeight="medium" gutterBottom>
              Incisor relationship
            </Typography>
            <Controller
              name="incisorRelationship"
              control={control}
              render={({ field }) => (
                <Grid container spacing={1}>
                  {[
                    "Class 1",
                    "Class 2 Div I",
                    "Class 2 Div II",
                    "Class 3",
                  ].map((option) => (
                    <Grid item key={option}>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="radio"
                          value={option}
                          checked={field.value === option}
                          onClick={() => field.onChange(option)}
                          style={{ marginRight: 8 }}
                        />
                        <Typography variant="body2">{option}</Typography>
                      </label>
                    </Grid>
                  ))}
                </Grid>
              )}
            />
          </Grid>

          {/* Overjet and Overbite */}
          <Grid item xs={12} md={6}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Controller
                  name="overjetMM"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Overjet (mm)"
                      type="number"
                      size="small"
                      fullWidth
                      variant="outlined"
                      {...field}
                      onChange={(e) =>
                        field.onChange(parseInt(e.target.value) || 0)
                      }
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name="overbiteMM"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Overbite (mm)"
                      type="number"
                      size="small"
                      fullWidth
                      variant="outlined"
                      {...field}
                      onChange={(e) =>
                        field.onChange(parseInt(e.target.value) || 0)
                      }
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Periodontal and Tonsils Section */}
        <Grid
          container
          spacing={3}
          sx={{ m: 2, p: 2, backgroundColor: "#f8f9fa", borderRadius: 2 }}
        >
          {/* Periodontal Condition */}
          <Grid item xs={12} md={6}>
            <Typography variant="body2" fontWeight="medium" gutterBottom>
              Periodontal condition
            </Typography>
            <Controller
              name="periodontalCondition"
              control={control}
              render={({ field }) => (
                <Grid container spacing={1}>
                  {["Good", "Fair", "Poor"].map((option) => (
                    <Grid item key={option}>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="radio"
                          value={option}
                          checked={field.value === option}
                          onClick={() => field.onChange(option)}
                          style={{ marginRight: 8 }}
                        />
                        <Typography variant="body2">{option}</Typography>
                      </label>
                    </Grid>
                  ))}
                </Grid>
              )}
            />
            {errors.periodontalCondition && (
              <Typography color="error" variant="caption">
                {errors.periodontalCondition.message}
              </Typography>
            )}
          </Grid>

          {/* Tonsils Enlarged */}
          <Grid item xs={12} md={6}>
            <Typography variant="body2" fontWeight="medium" gutterBottom>
              Tonsils - enlarged/inflamed
            </Typography>
            <Controller
              name="tonsilsEnlarged"
              control={control}
              render={({ field }) => (
                <Grid container spacing={2}>
                  <Grid item>
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="radio"
                        checked={field.value === true}
                        onClick={() => field.onChange(true)}
                        style={{ marginRight: 8 }}
                      />
                      <Typography variant="body2">Yes</Typography>
                    </label>
                  </Grid>
                  <Grid item>
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="radio"
                        checked={field.value === false}
                        onChange={() => field.onChange(false)}
                        style={{ marginRight: 8 }}
                      />
                      <Typography variant="body2">No</Typography>
                    </label>
                  </Grid>
                </Grid>
              )}
            />
            {errors.tonsilsEnlarged && (
              <Typography color="error" variant="caption">
                {errors.tonsilsEnlarged.message}
              </Typography>
            )}
          </Grid>

          {/* Bruxism */}
          <Grid item xs={12} md={6}>
            <Typography variant="body2" fontWeight="medium" gutterBottom>
              Bruxism/clenching/grinding of teeth
            </Typography>
            <Controller
              name="bruxism"
              control={control}
              render={({ field }) => (
                <Grid container spacing={2}>
                  <Grid item>
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="radio"
                        checked={field.value === true}
                        onClick={() => field.onChange(true)}
                        style={{ marginRight: 8 }}
                      />
                      <Typography variant="body2">Yes</Typography>
                    </label>
                  </Grid>
                  <Grid item>
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="radio"
                        checked={field.value === false}
                        onClick={() => field.onChange(false)}
                        style={{ marginRight: 8 }}
                      />
                      <Typography variant="body2">No</Typography>
                    </label>
                  </Grid>
                </Grid>
              )}
            />
            {errors.bruxism && (
              <Typography color="error" variant="caption">
                {errors.bruxism.message}
              </Typography>
            )}
          </Grid>
        </Grid>

        {/* TMJ Assessment Section */}
        <Grid
          container
          spacing={3}
          sx={{ m: 2, p: 2, backgroundColor: "#f8f9fa", borderRadius: 2 }}
        >
          <Grid item xs={12}>
            <Typography
              variant="h6"
              fontWeight="bold"
              color="primary"
              gutterBottom
            >
              TMJ Assessment
            </Typography>
          </Grid>

          {/* Max Lateral Movements */}
          <Grid item xs={12} md={6}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={4}>
                <Typography variant="body2">Max lateral movements</Typography>
              </Grid>
              <Grid item xs={4}>
                <Controller
                  name="maxLateralMovement_L_MM"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Left (mm)"
                      type="number"
                      size="small"
                      fullWidth
                      variant="outlined"
                      {...field}
                      onChange={(e) =>
                        field.onChange(parseInt(e.target.value) || 0)
                      }
                    />
                  )}
                />
              </Grid>
              <Grid item xs={4}>
                <Controller
                  name="maxLateralMovement_R_MM"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Right (mm)"
                      type="number"
                      size="small"
                      fullWidth
                      variant="outlined"
                      {...field}
                      onChange={(e) =>
                        field.onChange(parseInt(e.target.value) || 0)
                      }
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Max Opening and Protrusion */}
          <Grid item xs={12} md={6}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={6}>
                <Controller
                  name="maxOpeningMM"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Max opening (mm)"
                      type="number"
                      size="small"
                      fullWidth
                      variant="outlined"
                      {...field}
                      onChange={(e) =>
                        field.onChange(parseInt(e.target.value) || 0)
                      }
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name="maxProtrusionMM"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Max protrusion (mm)"
                      type="number"
                      size="small"
                      fullWidth
                      variant="outlined"
                      {...field}
                      onChange={(e) =>
                        field.onChange(parseInt(e.target.value) || 0)
                      }
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* TMJ Symptoms */}
          <Grid item xs={12}>
            <Grid container spacing={2}>
              {[
                {
                  name: "tendernessToPalpitation",
                  label: "Tenderness to palpitation",
                },
                {
                  name: "painOnMandibularMovement",
                  label: "Pain on mandibular movement",
                },
                { name: "smoothMovement", label: "Smooth movement" },
                { name: "lockingOrLuxation", label: "Locking and/or luxation" },
              ].map((item) => (
                <Grid item xs={12} md={6} key={item.name}>
                  <Typography variant="body2" fontWeight="medium" gutterBottom>
                    {item.label}
                  </Typography>
                  <Controller
                    name={item.name}
                    control={control}
                    render={({ field }) => (
                      <>
                        <Grid container spacing={2}>
                          <Grid item>
                            <label
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                              }}
                            >
                              <input
                                type="radio"
                                checked={field.value === true}
                                onClick={() => field.onChange(true)}
                                style={{ marginRight: 8 }}
                              />
                              <Typography variant="body2">Yes</Typography>
                            </label>
                          </Grid>
                          <Grid item>
                            <label
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                              }}
                            >
                              <input
                                type="radio"
                                checked={field.value === false}
                                onClick={() => field.onChange(false)}
                                style={{ marginRight: 8 }}
                              />
                              <Typography variant="body2">No</Typography>
                            </label>
                          </Grid>
                        </Grid>
                        {errors[item.name] && (
                          <Typography color="error" variant="caption">
                            {errors[item.name]?.message}
                          </Typography>
                        )}
                      </>
                    )}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>

        {/* Care Pathway Section */}
        <Grid
          container
          spacing={3}
          sx={{ m: 2, p: 2, backgroundColor: "#e8f4fd", borderRadius: 2 }}
        >
          <Grid item xs={12}>
            <Typography
              variant="h6"
              fontWeight="bold"
              color="primary"
              gutterBottom
            >
              CARE PATHWAY
            </Typography>
            <Typography variant="body2" sx={{ mb: 3, fontStyle: "italic" }}>
              If the following are reported, a Sleep Study should be completed
              to determine if the patient has OSA and the Informed consent
              should be completed.
            </Typography>

            <Grid container spacing={2}>
              {[
                { name: "epworth10Plus", label: "Epworth of 10+" },
                { name: "feelingFatigued", label: "Feeling fatigued" },
                { name: "notUsingCPAP", label: "Not using CPAP" },
                { name: "headaches", label: "Headaches" },
                {
                  name: "inappropriateDaytimeNapping",
                  label:
                    "Inappropriate daytime napping (e.g., during driving, conversation, or eating)",
                },
                {
                  name: "ahI5Plus",
                  label:
                    "AHI of 5 or above (only if the patient has already had a sleep test in the past)",
                },
              ].map((item) => (
                <Grid item xs={12} key={item.name}>
                  <Controller
                    name={item.name}
                    control={control}
                    render={({ field }) => (
                      <label
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          cursor: "pointer",
                        }}
                      >
                        <Checkbox
                          checked={field.value || false}
                          onClick={(e) => field.onChange(!field.value)}
                          style={{ marginTop: -4 }}
                        />
                        <Typography variant="body2">{item.label}</Typography>
                      </label>
                    )}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>

        {/* Provider Information */}
        <Grid
          container
          spacing={3}
          sx={{ m: 2, p: 2, backgroundColor: "#f8f9fa", borderRadius: 2 }}
        >
          <Grid item xs={12}>
            <Typography
              variant="h6"
              fontWeight="bold"
              color="primary"
              gutterBottom
            >
              Provider Information
            </Typography>
          </Grid>

          <Grid item xs={12} md={4}>
            <Controller
              name="providerName"
              control={control}
              render={({ field }) => (
                <TextField
                  label="Provider Name"
                  size="small"
                  fullWidth
                  variant="outlined"
                  {...field}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <Controller
              name="providerSignature"
              control={control}
              render={({ field }) => (
                <TextField
                  label="Provider Signature"
                  size="small"
                  fullWidth
                  variant="outlined"
                  {...field}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <Controller
              name="providerDate"
              control={control}
              render={({ field }) => (
                <TextField
                  label="Date"
                  type="date"
                  size="small"
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  {...field}
                  value={field.value || ""}
                />
              )}
            />
          </Grid>
        </Grid>

        {/* Submit Button */}
        <Grid container justifyContent="flex-end" sx={{ mt: 4 }}>
          <Button
            type="submit"
            variant="contained"
            disabled={submitting}
            sx={{
              backgroundColor: "#A574FD",
              color: "white",
              minWidth: 120,
              height: 40,
              "&:hover": {
                backgroundColor: "#8A5CE6",
              },
            }}
          >
            {submitting ? "Saving..." : "Save"}
          </Button>
        </Grid>
      </form>
    </Container>
  );
};

export default DentistForm;
